import React from 'react';
import './OnlineSkeleton.scss';

const OnlineSkeleton: React.FC = () => {
  return (
    <div className="header_online online_skeleton">
      <div className="online_skeleton_icon"></div>
      <div className="online_skeleton_count"></div>
      <div className="online_skeleton_text"></div>
    </div>
  );
};

export default OnlineSkeleton; 
